import { useMemo } from 'react'
import { useConnections } from '@/features/integrations'

/**
 * Slugs of the user's active connections, for the ask-bar connections menu.
 *
 * Reads the same query as Settings, so connecting an app updates both surfaces
 * through cache invalidation rather than an event bus.
 *
 * @returns {string[]}
 */
export default function useConnectedToolkits() {
  const { data } = useConnections()

  return useMemo(
    () =>
      (data ?? [])
        .filter((connection) => connection.status === 'ACTIVE' && !connection.is_disabled)
        .map((connection) => String(connection.toolkit_slug ?? '').toLowerCase())
        .filter(Boolean),
    [data],
  )
}
